/**
 * `posts` — les actualités du site (base galerie, 4.1).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, slugSchema, withAudit } from './commun.js';
export const postSchema = withAudit(z.object({
    _id: idSchema,
    titre: bilingueSchema,
    slug: slugSchema,
    chapo: bilingueSchema.optional(),
    texte: bilingueSchema,
    medias: z.array(idSchema).default([]),
    date: z.date(),
    visibleSurLeSite: z.boolean().default(false),
}));
export const postCreationSchema = postSchema.omit(CHAMPS_DOCUMENT);
export const postMiseAJourSchema = postCreationSchema.partial();
//# sourceMappingURL=posts.js.map